import React from 'react';

const TuitionInfo = ({ monthly, period, description }) => {
  return (
    <>
      <p>Měsíční platba: {monthly}</p>
      {period && <p>Období: {period}</p>}
      {description && <p>{description}</p>}
    </>
  );
};

export default TuitionInfo; 